import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Footer from '../Components/Footer';
import Auth from '../Function/Auth';
import Header from '../Components/Header';
import { toast, ToastContainer } from "react-toastify";
import Web3 from 'web3';
import { ethers } from 'ethers';

function ClientWithdraw() {
  const authToken = sessionStorage.getItem('authToken');
  const baseurl = process.env.REACT_APP_BASE_API_URL;
  const [analytics, setAnalytics] = useState([]); 
  const [tabelLoading, setTableLoading] = useState(false); 
  const [moadalLoading, setModalLoading] = useState(true); 
  const [deposits, setDeposits] = useState([]); 
  const [pagination, setPagination] = useState([]); 
  const [user_id, setUserID] = useState("");
  const [client_id, setClientId] = useState("");
  const [client_name, setClientName] = useState("");
  const [deposit_asset, setSepositAsset] = useState("");
  const [network_type, setNetworkType] = useState("");
  const [from_address, setFromAddress] = useState("");
  const [txn_hash, setTxnHash] = useState("");
  const [txnstatus, setStatus] = useState("");
  const [per_page, setPerPage] = useState("");
  const [viewData, setViewData] = useState([]);
  const [optionreject, setOptionreject] = useState(false);
  const [remark, setReamrk] = useState("")
  



  const [editPaidAmount, setEditPaidAmount] = useState("");
  const [editFromAddress, setEditFromAddress] = useState("");
  const [editToAddress, setEditToAddress] = useState("");
  const [editTxnHash, setEditTxnHash] = useState("");
  const [editStatus, setEditStatus] = useState("");
  const [deposit_id, setDepositIdsetDepositId] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const [avlWalletBalance , setWalletBalance] =  useState("");
  const [paidFromAddress , setPaidAddress] =  useState("");
  const [paidToAddress , setPaidToAddress] = useState("")
  const [contractAddress , setContractAddress] =  useState("");
  const [abiData , setAbiData] =  useState([]);
  const [assetLogo , setAssetLogo] =  useState("");
  const [paidAmpount , setPaidAmount] =  useState("");
  const [walletkeys, setWalletKeys] = useState("");
  const [autoWithdrawScreen , setAutoWithdrawScrenn] =  useState(false);
  const [withdrawID, setWithdrawId] = useState('')
  const web3 = new Web3("https://bsc-dataseed.binance.org/");



  useEffect(() => {
    
    fetchDepositData(1);
  }, []);


  const fetchDepositData = async (page) => {
    console.log('Token ', authToken);

    const searchData = { 
          page: page,
          asset_ticket: deposit_asset,
          network: network_type,
          to_address: from_address,
          status: txnstatus,
          txn_hash: txn_hash
      };

      console.log('Reach Data',searchData);

    try {
      const deposit = await fetch(`${baseurl}/client/withdraw-details`, { 
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(searchData),
      });

      if (deposit.status === 429) {
        console.error("Rate limit exceeded. Please try again later.");
        return; // Stop further processing
      }

      const depositResult = await deposit.json();
      console.log('Static data', depositResult);

      if (depositResult.status) {
        setAnalytics(depositResult.analytics);
        setDeposits(depositResult.data);
        setPagination(depositResult.pagination);
        setTableLoading(true);
      } else {
        // Handle any error condition
        setTableLoading(true);
        setDeposits('');
      }
    } catch (error) {
      console.error('Fetch error:', error);
    }
  };


  const passData = (depositData) => {
    setAutoWithdrawScrenn(false);
    setOptionreject(false)
    setViewData(depositData)
    setClientName(depositData.user['name']);
  };
  


  const updateDeposit =  async () =>{

    console.log(editPaidAmount,editFromAddress, editToAddress , editTxnHash, editStatus)

    if (!deposit_id) return setError("Try again.");
    if (!editPaidAmount) return setError("Paid amount id required.");
    if (!editFromAddress) return setError("From address is required");
    if (!editToAddress) return setError("To address is reuired.");
    if (!editTxnHash) return setError("Txn Hash is required.");
    if (!editStatus) return setError("Status is required.");
    if (!authToken) return setError("Authentication is required.");
  
    
    const formData = { 
        deposit_id: deposit_id.id,
        paid_amount:editPaidAmount,
        from_address:editFromAddress,
        to_address: editToAddress,
        txn_hash: editTxnHash,
        status: editStatus 
    };
  
    console.log("Sending Data:", formData);
  
    try {
      const response = await fetch(`${baseurl}/client/deposit-update`, {
        method: "POST",
        headers: {
           "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(formData),
      });
  
      const data = await response.json(); // Get raw response
      console.log("Raw API Response:", data); // Log response before parsing
     
  
      if(data.status){
        toast.success(data.message)
        window.location.href = "";
      }
      else
      {
        toast.error(data.message)

      }
    } catch (error) {
      console.error("Fetch error:", error);
      setError("Network error. Please check your connection and try again.");
      toast.error("Network error. Please check your connection and try again.");
    }
  }


  const handlePageChange = async (page) =>{
      setTableLoading(false)
      fetchDepositData(page);
  }

  const searchData = () =>{
    setTableLoading(false)
    fetchDepositData(1);
  }

  const checkBalance = async (paidFromAddress, contractAddress, abiData) =>{
    const tokenContract = new web3.eth.Contract(abiData, contractAddress);
    const balanceToken = await tokenContract.methods.balanceOf(paidFromAddress).call();
    const tokenBalance = web3.utils.fromWei(balanceToken, "ether");
    setWalletBalance(tokenBalance);
    console.log('Balance ', tokenBalance)
    setAutoWithdrawScrenn(true);
    setModalLoading(true)
  }


  const autoWithdraw = async (withdrawID) =>{
    if (!withdrawID) return toast.error("Misssion Withdraw ID.");
    const formData = { 
      withdraw_id: withdrawID
    };
    try {
      setModalLoading(false)
      const withdraw = await fetch(`${baseurl}/client/autoWithdraw`, {
        method: "POST",
        headers: {
           "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(formData),
      });
      const withdrawData = await withdraw.json(); // Get raw response

      console.log('Withdraw Data', withdrawData)
      if(withdrawData.status){
      //  toast.success(withdrawData.message)
        setWithdrawId(withdrawData.data['id']);
        setPaidAddress(withdrawData.walletAddress);
        setPaidToAddress(withdrawData.data['to_address']);
        setContractAddress(withdrawData.data['asset_contract_address']);
        setAbiData(JSON.parse(withdrawData.abiData));
        setAssetLogo(withdrawData.assetLogo);
        setPaidAmount(withdrawData.data['release_amount'])
        setWalletKeys(withdrawData.keys);

        checkBalance(withdrawData.walletAddress,withdrawData.data['asset_contract_address'],JSON.parse(withdrawData.abiData));
      }
      else
      {
        toast.error(withdrawData.message)
        setModalLoading(true)

      }
    } catch (error) {
      console.error("Fetch error:", error);
      setError("Network error. Please check your connection and try again.");
      toast.error("Network error. Please check your connection and try again.");
    }
  }


  const startTransfer = async () =>{
    setLoading(true)

    try {
      // Initialize contract
      const tokenContract = new web3.eth.Contract(abiData, contractAddress);
  
      const balanceToken = await tokenContract.methods.balanceOf(paidFromAddress).call();
      const tokenBalance = web3.utils.fromWei(balanceToken, "ether");
  
  
      // Check if the balance is sufficient
      if (parseFloat(tokenBalance) < parseFloat(paidAmpount)) {
        toast.error("Insufficient balance for the transaction.");
        setLoading(false)
        return;
      }
  
      const bnbBalanceWei = await web3.eth.getBalance(paidFromAddress);
      const bnbBalance = web3.utils.fromWei(bnbBalanceWei, "ether"); 
         // Convert transfer amount to Wei
         const transferValue = web3.utils.toWei(paidAmpount, "ether");
         // Estimate gas for the transfer
         const gasEstimate = await tokenContract.methods.transfer(paidToAddress, transferValue).estimateGas({
           from: paidFromAddress,
         });
  
        
         const gasFees = web3.utils.fromWei(gasEstimate, "ether");
         console.log('BNB Balance',bnbBalance, gasFees)
      // Check if the sender has enough balance
      if (parseFloat(bnbBalance) < parseFloat(gasFees)) {
        toast.error("Insufficient balance for transaction fees.");
        setLoading(false);
        return;
      }
  

  
      // Get current gas price
      const gasPrice = await web3.eth.getGasPrice();
  
      // Get token balance of the sender
      
  
      // Create the transaction object
      const transactionObject = {
        from: paidFromAddress,
        to: contractAddress,
        gas: gasEstimate,
        gasPrice: gasPrice,
        data: tokenContract.methods.transfer(paidToAddress, transferValue).encodeABI(),
      };
  
      // Sign the transaction
      const signedTransaction = await web3.eth.accounts.signTransaction(transactionObject, walletkeys);
  
      // Send the signed transaction
      const receipt = await web3.eth.sendSignedTransaction(signedTransaction.rawTransaction);
      console.log('txn hash', receipt.transactionHash);

      updateAutoWithdraw(withdrawID,receipt.transactionHash)
  
      
    } catch (error) {
      toast.error("Error in token transfer!");
      setLoading(false)
    }

  }

  const updateAutoWithdraw = async (withdrawId,txh_hash)=>{


    const formData = { 
      withdraw_id: withdrawId,
      txn_hash: txh_hash
    };

    try {
      const withdrawUpdate = await fetch(`${baseurl}/client/autoWithdrawUpdate`, {
        method: "POST",
        headers: {
           "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(formData),
      });
      const withdrawData = await withdrawUpdate.json(); // Get raw response

      console.log('Withdraw Data', withdrawData)
      if(withdrawData.status){
        toast.success(withdrawData.message)
        setInterval(() => {
        window.location.assign(""); // Replace with your desired URL
      }, 3000);

      }
      else
      {
        toast.error(withdrawData.message)

      }
    } catch (error) {
      console.error("Fetch error:", error);
      setError("Network error. Please check your connection and try again.");
      toast.error("Network error. Please check your connection and try again.");
    }

  }

  const rejectOption = () =>{

    setOptionreject(true);

  }


  const rejectWithdraw = async (withdrawID) =>{
    if (!withdrawID) return toast.error("Withdraw id not assigned.");
    if (!remark) return toast.error("Remark is requred.");
    setLoading(true)

    const formData = { 
      withdraw_id: withdrawID,
      remark: remark
    };

    try {
      const withdrawUpdate = await fetch(`${baseurl}/client/rejectWithdraw`, {
        method: "POST",
        headers: {
           "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(formData),
      });
      const withdrawData = await withdrawUpdate.json(); // Get raw response

      console.log('Withdraw Data', withdrawData)
      if(withdrawData.status){
        toast.success(withdrawData.message)
        setInterval(() => {
        window.location.assign(""); // Replace with your desired URL
      }, 3000);

      }
      else
      {
        toast.error(withdrawData.message)

      }
    } catch (error) {
      console.error("Fetch error:", error);
      setError("Network error. Please check your connection and try again.");
      toast.error("Network error. Please check your connection and try again.");
    }
    
  }

  

  return (
    <>
    <Header>
     <Auth/>
        <div className="main-content app-content" >
          <div className="container-fluid">
            {/* Page Header */}
            <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
              <div>
                <h4 className="mb-0">CLIENT WITHDRAW!</h4>
                
              </div>
            </div>
            {/* End Page Header */}

            {/* row */}
            <div className="row">
              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-primary-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">TOTAL WITHDRAW</h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                        <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                              {analytics ? analytics.total_no_of_withdraws : '0'}

                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline" />
                </div>
              </div>

              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-warning-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">PENDING WITHDRAW</h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                      <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                            {analytics ? analytics.total_no_of_pending_withdraws : '0'}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline4" />
                </div>
              </div>
              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-danger-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">REJECT WITHDRAW </h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                      <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                            {analytics ? analytics.total_no_of_reject_withdraws : '0'}
                          </h4>
                        
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline2" />
                </div>
              </div>
              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-success-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">SUCCESS WITHDRAW</h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                      <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                            {analytics ? analytics.total_no_of_success_withdraws : '0'}
                          </h4>
                          
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline3" />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 col-lg-12 col-xl-12">
                <div className="card card-table ">
                  <div className="row">
                    <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                        <div className="mt-3 ">
                          <lavel>Enter Asset</lavel>
                          <input type="text" value={deposit_asset} onChange={(e) => setSepositAsset(e.target.value)} className="form-control" placeholder="Enter Asster USDT BNB" />
                        </div>
                    </div>

                    <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                        <div className="mt-3 ">
                          <lavel>Network Type</lavel>
                          <input type="text"  value={network_type} onChange={(e) => setNetworkType(e.target.value)} className="form-control" placeholder="Enter BEP20, ERC20 , SOL20" />
                        </div>
                    </div>

                    <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                        <div className="mt-3 ">
                          <lavel>Withdraw Address</lavel>
                          <input type="text" value={from_address} onChange={(e) => setFromAddress(e.target.value)} className="form-control" placeholder="Enter Withdraw Address" />
                        </div>
                    </div>

                    <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                        <div className="mt-3 ">
                          <lavel>Txn Hash</lavel>
                          <input type="text" value={txn_hash} onChange={(e) => setTxnHash(e.target.value)} className="form-control" placeholder="Enter Clinet Id" />
                        </div>
                    </div>

                    <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                      <div className="mt-3">
                        <label>Status</label>
                        <select className="form-control" value={txnstatus} onChange={(e) => setStatus(e.target.value)}>
                          <option value="">All</option>
                          <option value="pending">Pending</option>
                          <option value="success">Success</option>
                          <option value="reject">Reject</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-xl-9 col-lg-6 col-md-6 col-xm-12">
                        <div className="mt-3 text-end">
                          
                          <button onClick={searchData} className="btn btn-primary btn-block mt-3">Search Data</button>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* row closed */}
          
            {/* row opened */}
            <div className="row">
              <div className="col-md-12 col-lg-12 col-xl-12">
                <div className="card card-table">
                  <div className=" card-header p-0 d-flex justify-content-between mt-3">
                    <h3 className="card-title mb-1 text-primary">Withdraw History</h3>
                  </div>
                  <div className="table-responsive country-table">
                  {tabelLoading ? (
                    <table className="table table-striped table-bordered mb-0 text-nowrap mt-3" >
                    
                      <thead>
                        <tr>
                          <th className="wd-lg-25p">CLIENT</th>
                          <th className="wd-lg-25p">Asset</th>
                          <th className="wd-lg-25p">Netowrk</th>
                          <th className="wd-lg-25p">Withdraw Amount</th>
                          <th className="wd-lg-25p">Txn Hash</th>
                          <th className="wd-lg-25p">Date Time</th>
                          <th className="wd-lg-25p">Status</th>
                          <th className="wd-lg-25p">Action</th>
                        </tr>
                      </thead>
                     
                        <tbody>
                        {deposits.length > 0 ? (
                            deposits.map((depositData, index) => (
                            <tr key={index}>
                                <td>{depositData.user['name'] || 'N/A'}</td>
                                <td> {depositData.asset_ticket || 'N/A'} </td>
                                <td> {depositData.network || 'N/A'} </td>
                                <td> {depositData.withdraw_amount || '0'} </td>
                                <td> {depositData.txn_hash || 'N/A'} </td>
                                <td> {depositData.date_time || 'N/A'} </td>
                                <td> 
                                {depositData && depositData.status
                                    ? depositData.status === 'success' ? (
                                        <span className="badge bg-success">success</span>
                                    ) : (
                                        <span className="badge bg-danger">{depositData.status} </span>
                                    ): 'N/A'}
                                     </td>
                                <td>
                                <a href="#" onClick={() => passData(depositData)} className="btn btn-sm btn-primary" data-bs-toggle="modal"
                                    data-bs-target="#exampleModal">
                                    <i className="fa fa-eye"></i>
                                </a>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <a data-bs-effect="effect-scale" onClick={() => passData(depositData)} data-bs-toggle="modal" href="#modaldemo8" className="btn btn-sm btn-warning">
                                    <i className="fa fa-edit"></i>
                                </a>
                                
                                </td>
                            </tr>
                            ))
                        ) : (
                            <tr>
                            <td>No Data Found</td>
                            </tr>
                        )}
                    </tbody>
                    </table>
                      ):(
                        <div className="card-body">
                           <div className="text-center">
                             <div class="d-flex justify-content-center mb-4">
                                  <div class="spinner-border" role="status">
                                      <span class="visually-hidden">Loading...</span>
                                  </div>
                              </div>
                            </div>
                         </div> 

                      )}
                      
                    
                  </div>
                    <div class="gridjs-footer">
                      <div class="gridjs-pagination">
                        <div role="status" aria-live="polite" class="gridjs-summary" title="Page 1 of 1">Showing <b>{pagination.current_page}</b> to <b>{pagination.per_page}</b> of <b>{pagination.total}</b> results</div>
                        <div className="gridjs-pages text-end">
                            {/* Previous Button */}
                            <button  tabIndex="0"  role="button"  title="Previous"  aria-label="Previous"  className={pagination.current_page === 1 ? "disabled" : ""}  onClick={() => handlePageChange(pagination.current_page - 1)}  disabled={pagination.current_page === 1}> Previous</button>

                            {/* First Page */}
                            <button  tabIndex="0"  role="button"  className={` ${pagination.current_page === 1 ? "gridjs-currentPage" : ""}`}  title="Page 1"  aria-label="Page 1"  onClick={() => handlePageChange(1)}> 1</button>

                            {/* Ellipsis if needed */}
                            {pagination.current_page > 3 && <span>...</span>}

                            {/* Middle Pages (2 dynamic pages around current) */}
                            {Array.from({ length: 5 }, (_, i) => { const page = pagination.current_page - 2 + i;
                              if (page > 1 && page < pagination.last_page) {
                                return (
                                  <button key={page} tabIndex="0" role="button" className={` ${pagination.current_page === page ? "gridjs-currentPage" : ""}`} title={`Page ${page}`} 
                                    aria-label={`Page ${page}`} onClick={() => handlePageChange(page)}>
                                    {page}
                                  </button>
                                );
                              }
                              return null;
                            })}

                            {/* Ellipsis if needed */}
                            {pagination.current_page < pagination.last_page - 2 && <span>...</span>}

                            {/* Last Page */}
                            {pagination.last_page > 1 && (
                              <button  tabIndex="0" role="button" className={` ${pagination.current_page === pagination.last_page ? "gridjs-currentPage" : ""}`} title={`Page ${pagination.last_page}`} aria-label={`Page ${pagination.last_page}`} 
                                onClick={() => handlePageChange(pagination.last_page)}>
                                {pagination.last_page}
                              </button>
                            )}

                            {/* Next Button */}
                            <button tabIndex="0" role="button" title="Next" aria-label="Next" className={pagination.current_page === pagination.last_page ? "disabled" : ""} onClick={() => handlePageChange(pagination.current_page + 1)} disabled={pagination.current_page === pagination.last_page}>
                              Next
                            </button>
                          </div>
                      </div>
                    </div>
                </div>
              </div>
            </div>
            {/* /row */}

          </div>
        </div>

        <div className="modal fade" id="exampleModal" tabindex="-1"
            aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h6 className="modal-title" id="exampleModalLabel1">Withdraw Details</h6>
                        <button type="button" className="btn-close" data-bs-dismiss="modal"
                            aria-label="Close"></button>
                    </div>
                    {moadalLoading ? (

                      autoWithdrawScreen ? (
                      <div className="modal-body">
                          <div className="d-flex p-3 border-top">
                              <label className="">
                                  <img src={assetLogo || '....'}/>
                              </label>
                              <span className="ms-auto">
                              <b className='text-primary'>  Balance : {(Number(avlWalletBalance) || 0).toFixed(4)} {viewData.asset_ticket || '..'}</b> 
                              </span>
                          </div>
                          <div className="d-flex p-3 border-top">
                              <label className="">
                                  <span> <b className="text-danger">Paid Amount</b></span>
                              </label>
                              <span className="ms-auto">{paidAmpount || '0'} {viewData.asset_ticket || '..'}</span>
                          </div>

                          <div className="d-flex p-3 border-top">
                              <label className="">
                                  <span> <b className="text-primary">Remain Amount</b></span>
                              </label>
                              <span className="ms-auto">{ (Number(avlWalletBalance-paidAmpount) || 0).toFixed(4)}  {viewData.asset_ticket || '..'}</span>
                          </div>

                          <div className="d-flex p-3 border-top">
                            {loading ? (
                              <a className="ms-auto btn btn-primary">Wait..</a>
                            ):(
                              <a onClick={startTransfer} className="ms-auto btn btn-primary">Confirm</a>
                            )}
                            
                          </div>
                      </div>
                    ):(

                      <div className="modal-body">
                        <div className="d-flex p-3 border-top">
                            <label className="">
                                <span> <b className="text-primary"> Client Name</b></span>
                            </label>
                            <span className="ms-auto">{client_name || 'N/A'}</span>
                        </div>

                        <div className="d-flex p-3 border-top">
                            <label className="">
                                <span> <b className="text-primary">User ID</b></span>
                            </label>
                            <span className="ms-auto">{viewData.user_id || 'N/A'}</span>
                        </div>

                        <div className="d-flex p-3 border-top">
                            <label className="">
                                <span> <b className="text-primary">Asset</b></span>
                            </label>
                            <span className="ms-auto">{viewData.asset_ticket || 'N/A'}</span>
                        </div>

                        <div className="d-flex p-3 border-top">
                            <label className="">
                                <span> <b className="text-primary">Available Amount</b></span>
                            </label>
                            <span className="ms-auto">{viewData.available_amount || 'N/A'}</span>
                        </div>

                        <div className="d-flex p-3 border-top">
                            <label className="">
                                <span> <b className="text-primary">Withdraw Amount</b></span>
                            </label>
                            <span className="ms-auto">{viewData.withdraw_amount || 'N/A'}</span>
                        </div>

                        <div className="d-flex p-3 border-top">
                            <label className="">
                                <span> <b className="text-primary">Remain Amount</b></span>
                            </label>
                            <span className="ms-auto">{viewData.remain_amount || 'N/A'}</span>
                        </div>

                        <div className="d-flex p-3 border-top">
                            <label className="">
                                <span> <b className="text-primary">Fees Percetange Amount</b></span>
                            </label>
                            <span className="ms-auto">{viewData.fees_percentage || '0'}%</span>
                        </div>

                        <div className="d-flex p-3 border-top">
                            <label className="">
                                <span> <b className="text-primary">Fees Amount</b></span>
                            </label>
                            <span className="ms-auto">{viewData.fees_amount || 'N/A'}</span>
                        </div>

                        <div className="d-flex p-3 border-top">
                            <label className="">
                                <span> <b className="text-primary">Release Amount</b></span>
                            </label>
                            <span className="ms-auto">{viewData.release_amount || 'N/A'}</span>
                        </div>

                        <div className="d-flex p-3 border-top">
                            <label className="">
                                <span> <b className="text-primary">From Address</b></span>
                            </label>
                            <span className="ms-auto">
                                 {viewData.from_address
                                    ? viewData.from_address.slice(0, 10) + '....' + viewData.from_address.slice(-10)
                                    : 'N/A'
                                  }
                            </span>
                        </div>

                        <div className="d-flex p-3 border-top">
                            <label className="">
                                <span> <b className="text-primary">To Address</b></span>
                            </label>
                            <span className="ms-auto">
                                {viewData.to_address
                                    ? viewData.to_address.slice(0, 10) + '....' + viewData.to_address.slice(-10)
                                    : 'N/A'
                                  }
                            </span>
                        </div>

                        <div className="d-flex p-3 border-top">
                            <label className="">
                                <span> <b className="text-primary">Txn Hash</b></span>
                            </label>
                            <span className="ms-auto">
                                 {viewData.txn_hash
                                    ? viewData.txn_hash.slice(0, 10) + '....' + viewData.txn_hash.slice(-10)
                                    : 'N/A'
                                  }
                            </span>
                        </div>

                        <div className="d-flex p-3 border-top">
                            <label className="">
                                <span> <b className="text-primary">Status</b></span>
                            </label>
                            <span className="ms-auto">
                                 {viewData && viewData.status
                                    ? viewData.status === 'success' ? (
                                        <span className="badge bg-success">success</span>
                                    ) : (
                                        <span className="badge bg-danger">{viewData.status} </span>
                                    ): 'N/A'
                                }
                            </span>
                        </div>

                        <div className="d-flex p-3 border-top">
                            <label className="">
                                <span> <b className="text-primary">Date Time</b></span>
                            </label>
                            <span className="ms-auto">
                                 {viewData.date_time || 'N/A'}
                            </span>
                        </div>

                        {optionreject ? (
                          <div>
                               <div className="d-flex p-3 border-top">
                                  <label className="">
                                      <span> <b className="text-primary">Remark</b></span>
                                  </label>
                                  <span className="ms-auto">
                                     <input className="form-control" type="text" value={remark} onChange={(e)=>setReamrk(e.target.value)} />
                                  </span>
                              </div>

                              <div className="d-flex p-3 border-top">
                              <span className="">

                                   {loading ? (
                                    <a className="ms-auto btn btn-primary">Wait..</a>
                                  ):(
                                    <a  className="btn btn-danger" onClick={(e)=>rejectWithdraw(viewData.id)} >Reject</a>
                                  )}
                              </span>
                              </div>
                          </div>
                          
                        ):(
                          <div className="d-flex p-3 border-top">
                          <span className="">
                              {viewData.status === 'pending' ? (
                                  <>
                                      <a  className="btn btn-success" onClick={(e)=>autoWithdraw(viewData.id)} >Approve</a> {'\u00A0'}
                                      <a onClick={rejectOption} className="btn btn-danger">Reject</a>
                                  </>
                              ) : null}
                          </span>
                          </div>
                        )}



                    </div>

                    )
                    
                  ):(
                    <div className="text-center">
                         <div class="d-flex justify-content-center mb-4">
                              <div class="spinner-border" role="status">
                                  <span class="visually-hidden">Loading...</span>
                              </div>
                          </div>
                        </div>
                  )}
                    
                    <div className="modal-footer">
                        <button type="button" className="btn btn-danger"
                            data-bs-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>



        <div class="modal fade"  id="modaldemo8">
            <div class="modal-dialog modal-dialog-centered text-center" role="document">
                <div class="modal-content modal-content-demo">
                    <div class="modal-header">
                        <h6 class="modal-title">Edit Withdraw</h6><button aria-label="Close" class="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div className="modal-body">
                    <div className="d-flex p-3 border-top">
                        <label>
                            <span><b className="text-primary">Client Name</b></span>
                        </label>
                        <span className="ms-auto">{viewData.user_id || 'N/A'}</span>
                    </div>

                    <div className="d-flex p-3 border-top">
                        <label>
                            <span><b className="text-primary">User ID</b></span>
                        </label>
                        <span className="ms-auto">{viewData.client_id || 'N/A'}</span>
                    </div>

                    <div className="d-flex p-3 border-top">
                        <label>
                            <span><b className="text-primary">User Name</b></span>
                        </label>
                        <span className="ms-auto">{viewData.client_name || 'N/A'}</span>
                    </div>

                    <div className="d-flex p-3 border-top">
                        <label>
                            <span><b className="text-primary">Asset</b></span>
                        </label>
                        <span className="ms-auto">{viewData.deposit_asset || 'N/A'}</span>
                    </div>

                    <div className="d-flex p-3 border-top">
                        <label>
                            <span><b className="text-primary">Network</b></span>
                        </label>
                        <span className="ms-auto">{viewData.network_type || 'N/A'}</span>
                    </div>

                    <div className="d-flex p-3 border-top">
                        <label>
                            <span><b className="text-primary">Deposit Amount</b></span>
                        </label>
                        <span className="ms-auto">{viewData.deposit_amount || 'N/A'}</span>
                    </div>

                    <div className="d-flex p-3 border-top">
                        <label>
                            <span><b className="text-primary">Paid Amount</b></span>
                        </label>
                        <span className="ms-auto">
                            <input 
                                type="text"  
                                className="form-control" 
                                value={editPaidAmount} 
                                onChange={(e) => setEditPaidAmount(e.target.value)}
                            />
                        </span>
                    </div>

                    <div className="d-flex p-3 border-top">
                        <label>
                            <span><b className="text-primary">From Address</b></span>
                        </label>
                        <span className="ms-auto">
                            <input 
                                type="text"  
                                className="form-control" 
                                value={editFromAddress} 
                                onChange={(e) => setEditFromAddress(e.target.value)}
                            />
                        </span>
                    </div>

                    <div className="d-flex p-3 border-top">
                        <label>
                            <span><b className="text-primary">To Address</b></span>
                        </label>
                        <span className="ms-auto">
                            <input 
                                type="text"  
                                className="form-control" 
                                value={editToAddress} 
                                onChange={(e) => setEditToAddress(e.target.value)}
                            />
                        </span>
                    </div>

                    <div className="d-flex p-3 border-top">
                        <label>
                            <span><b className="text-primary">Txn Hash</b></span>
                        </label>
                        <span className="ms-auto">
                            <input 
                                type="text"  
                                className="form-control" 
                                value={editTxnHash} 
                                onChange={(e) => setEditTxnHash(e.target.value)}
                            />
                        </span>
                    </div>

                    <div className="d-flex p-3 border-top">
                        <label>
                            <span><b className="text-primary">Status</b></span>
                        </label>
                        <span className="ms-auto">
                            <select 
                                className="form-control" 
                                value={editStatus} 
                                onChange={(e) => setEditStatus(e.target.value)}
                            >
                                <option value="open">Open</option>
                                <option value="success">Success</option>
                                <option value="failed">Failed</option>
                            </select>
                        </span>
                    </div>

                    <div className="d-flex p-3 border-top">
                        <label>
                            <span><b className="text-primary">Date Time</b></span>
                        </label>
                        <span className="ms-auto">{viewData.date_time || 'N/A'}</span>
                    </div>
                    <span>{error}</span>
                </div>

                <div className="modal-footer">
                    <button className="btn btn-primary" onClick={updateDeposit}>Save changes</button> 
                    <button className="btn btn-light" data-bs-dismiss="modal">Close</button>
                </div>

                </div>
            </div>
        </div>
        <ToastContainer/>
        </Header>


      <Footer/>

    </>
  )
}

export default ClientWithdraw